import { AppProps } from 'next/app';
import { ReactElement } from 'react';

// to include into '_app' chunk file
import 'firebase/app';
import 'firebase/analytics';

export type AppTypes = {
  skeleton: boolean;
};

export type AppComponentType = {
  render: (props: AppProps) => ReactElement;
};

const App = ({ Component, ...props }: AppProps & { Component: AppComponentType }) => {
  const render = Component.render || ((page: typeof Component) => page);

  return render({ Component, ...props });
};

export default App;
